module.exports = __webpack_public_path__ + "fonts/50bbc2d.woff";